import { PageHeader } from '@/components/shared/page-header';
import { TableSkeleton } from '@/components/shared/skeleton';

export function Loading() {
  return (
    <>
      <PageHeader title="Station closures" description="Manage maintenance windows and planned outages" />
      <TableSkeleton columns={6} />
    </>
  );
}
